export type IProjectKind = 'application' | 'template' | null
